module.exports = __webpack_public_path__ + "static/media/68.28361d57.png";